"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommuteSectionCategory = void 0;
var CommuteSectionCategory;
(function (CommuteSectionCategory) {
    CommuteSectionCategory["Overview"] = "Overview";
    CommuteSectionCategory["Bike"] = "Bike";
    CommuteSectionCategory["Walk"] = "Walk";
    CommuteSectionCategory["Transit"] = "Transit";
    CommuteSectionCategory["Parking"] = "Parking";
    CommuteSectionCategory["Carpool"] = "Carpool";
    CommuteSectionCategory["Vanpool"] = "Vanpool";
    CommuteSectionCategory["Shuttle"] = "Shuttle";
    CommuteSectionCategory["ElectricVehicle"] = "EV";
    CommuteSectionCategory["EmergencyRideHome"] = "Emergency Ride Home";
    CommuteSectionCategory["Remote"] = "Remote";
    CommuteSectionCategory["Bikeshare"] = "Bikeshare";
    CommuteSectionCategory["Carshare"] = "Carshare";
    CommuteSectionCategory["TaxiAndRideshare"] = "Taxi and rideshare";
    CommuteSectionCategory["EquipmentRental"] = "Equipment Rental";
    CommuteSectionCategory["Micromobility"] = "Micromobility";
    CommuteSectionCategory["Miscellaneous"] = "Miscellaneous";
})(CommuteSectionCategory || (exports.CommuteSectionCategory = CommuteSectionCategory = {}));
//# sourceMappingURL=CommuteSections.js.map